import { ButtonInline } from '@remote-com/norma/core/button';
import ArrowRightSvg from '@remote-com/norma/icons/arrow-right.svg';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import {
  OverviewSectionSingleRow,
  ImageWrapper,
  SectionCustomDescriptionComponent,
} from '@/src/components/OverviewSection/OverviewSectionRow';

const Wrapper = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '70px', '120px')}
  background-color: var(--colors-blank);

  ${SectionCustomDescriptionComponent} {
    ul,
    ol {
      li {
        margin-top: 5px;
      }
      li::marker {
        color: var(--colors-lynch);
      }
    }
  }
`;

const OverviewSectionWrapper = styled.div`
  ${fluidProp('padding-bottom', '5px', '120px')};
  ${fluidProp('padding-top', '10px', '50px')};

  ${ImageWrapper} {
    margin-bottom: 0;
  }
`;

const CtaWrapper = styled.div`
  margin-top: 15px;
`;

const ArrowIcon = styled(ArrowRightSvg)`
  width: 15px;
  margin-left: 16px;
  fill: var(--colors-irisBlue);
`;

export function OverviewSliceWithCtaSlice({ slice }) {
  const { fields: overviewSections } = transformProperties(slice);

  return (
    <Wrapper>
      <ContentContainer>
        {overviewSections.map(
          (
            {
              label,
              title,
              description: content,
              illustration,
              illustrationOnTheEdge: onEdge,
              icon,
              note,
              ctaLabel,
              ctaLink,
            },
            index
          ) => (
            <OverviewSectionWrapper key={index}>
              <OverviewSectionSingleRow
                label={label}
                title={title}
                description={content}
                illustration={illustration}
                illustration_on_the_edge={onEdge}
                directionOffset={(index + 1) % 2}
                icon={icon}
                note={note}
              />
              {ctaLink && ctaLabel && (
                <CtaWrapper>
                  <ButtonInline href={ctaLink?.url} target={ctaLink?.target}>
                    {ctaLabel}
                    <ArrowIcon />
                  </ButtonInline>
                </CtaWrapper>
              )}
            </OverviewSectionWrapper>
          )
        )}
      </ContentContainer>
    </Wrapper>
  );
}
